import * as ng from 'angular';
import * as Linq from 'linq-es5';
import { ISessionService, IToastMessageService } from '../../../services';
import { Dto, IAccountResource, IFrequentParkerAccountResource } from '../../../data';

let AccountAdminServiceFactory: Function =
    function ($q: ng.IQService,
        Session: ISessionService,
        Account: IAccountResource,
        toastMessageFactory: IToastMessageService,
        FrequentParkerAccount: IFrequentParkerAccountResource): IAccountAdminService {
        return new AccountAdminService($q, Session, Account, toastMessageFactory, FrequentParkerAccount);
    }

AccountAdminServiceFactory.$inject = ['$q', 'Session', 'Account', 'toastMessageFactory', 'FrequentParkerAccount'];

let AccountAdminServices = {
    name: "AccountAdmin",
    factory: AccountAdminServiceFactory
};

interface IAccountAdminService {
    search(criteria: Dto.IAccountCriteria): ng.IPromise<Array<Dto.IAccount>>;
    update(account: Dto.IAccount): ng.IPromise<Dto.IAccount>;
}

export class AccountAdminService implements IAccountAdminService {

    constructor(private $q: ng.IQService,
        private Session: ISessionService,
        private Account: IAccountResource,
        private toastMessageFactory: IToastMessageService,
        private FrequentParkerAccount: IFrequentParkerAccountResource) {

        console.log('AccountAdminService loading');



        //activate service
        this.activate();
    }

    //functions
    public activate(): void {
        console.log('AccountAdminService loaded');
    }

    public search(criteria: Dto.IAccountCriteria): ng.IPromise<Array<Dto.IAccount>> {
        let localCriteria = criteria || {} as Dto.IAccountCriteria;

        return this.Account.search(localCriteria).$promise
            .then((response) => {
                return this.$q.resolve(response);
            })
            .catch((e) => {
                //this.toastMessageFactory.showServerError();
                return this.$q.resolve([]);
            });
    }

    public update(account: Dto.IAccount): ng.IPromise<Dto.IAccount> {

        let promises = [];
        return this.FrequentParkerAccount
            .get({ accountId: account.id, id: account.frequentParkerAccountId }).$promise.then((fppAccount) => {
                var accountResponseIndex = 0;
                if (fppAccount && fppAccount.number != account.frequentParkerNumber) {
                    fppAccount.number = account.frequentParkerNumber;
                    let fppPromise = this.FrequentParkerAccount.update({accountId: account.id }, fppAccount).$promise;
                    promises.push(fppPromise);
                    accountResponseIndex++;
                }
                let accountPromise = this.Account.update(account).$promise;
                promises.push(accountPromise);

                return this.$q.all(promises)
                    .then((response) => {
                        //this.toastMessageFactory.showSuccessMessage();
                        return this.Account.get({ id: account.id }).$promise
                            .then((acct) => {
                                return acct;
                            });
                    })
                    .catch((e) => {
                        //this.toastMessageFactory.showServerError();
                        return this.$q.resolve(null);
                    });
            });
    }
    // private interface

}

export { AccountAdminServices, IAccountAdminService };
export default AccountAdminServices;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/admin/services/accounts-service.ts